import React, {Component, PropTypes} from 'react'
import {Route, Link, BrowserRouter as Router} from 'react-router-dom'
import HeaderDiv from '../Header/HeaderDiv'
import {Layout, Menu, Icon, Select} from 'antd'
import RoleIDMapping from '../hooks/Modules'
import {ContainerOutlined, ShrinkOutlined} from '@ant-design/icons'
const {SubMenu} = Menu
const {Header, Sider, Content} = Layout

const {option, OptGroup} = Select

class Layouts extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openKeys: '',
      collapsed: localStorage.getItem('collapsed') === 'true' || false,
      uni: '',
      loginUserRole: JSON.parse(localStorage.getItem('user'))?.role,
    }
  }

  reportWindowSize = () => {
    console.log('window.innerWidth', window.innerWidth)
    if (window.innerWidth < 568 && !this.state.collapsed) {
      console.log(this.state)
      this.setState({
        collapsed: true,
      })
    } else if (this.state.collapsed) {
      this.setState({collapsed: false})
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.reportWindowSize)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.reportWindowSize)
  }

  state = {
    collapsed: true,
    uni: '',
    location: '',
  }
  toggleSidebar = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
    localStorage.setItem('collapsed', !this.state.collapsed)
  }
  rootSubmenuKeys = ['sub1', 'sub2', 'sub4', 'sub5', 'sub3', 'sub6']

  state = {
    openKeys: '',
    collapsed: false,
  }

  // state = {
  //   collapsed: true,
  //   uni: '',
  // }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }
  rootSubmenuKeys = ['sub1', 'sub2', 'sub4', 'sub5', 'sub3', 'sub6']

  state = {
    openKeys: '',
    collapsed: false,
  }

  onOpenChange = openKeys => {
    const latestOpenKey = openKeys.find(
      key => this.state.openKeys.indexOf(key) === -1,
    )
    if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({openKeys})
    } else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : [],
      })
    }
  }
  render() {
    const active = this.props.active
    // const classname = (this.props, "classname", " ");
    return (
      <Layout className={`${this.props.classname}`}>
        <Sider
          trigger={null}
          collapsedWidth={0}
          collapsible
          collapsed={this.state.collapsed}
          width={250}
          style={{
            background: '#001529',
          }}
          className="sidebar-left"
          onCollapse={this.onCollapse}>
          <div className="logo" />
          <Menu
            theme="light"
            mode="inline"
            defaultSelectedKeys={[active]}
            openKeys={this.state.openKeys}
            onOpenChange={this.onOpenChange}
            // mode="vertical"
          >
            {/* <Menu.Item key="5">
              <Link to="/home">
                <div>
                  <Icon type="rollback" />
                  <span>Go Back</span>
                </div>
              </Link>
            </Menu.Item> */}
            {localStorage.getItem('userType') === 'Claims Processor' && (
              <Menu.Item key="1">
                <Link to="/validate">
                  <div>
                    <Icon type="dashboard" />
                    <span>Add Claim </span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            {localStorage.getItem('userType') === 'Claims Manager' && (
              <Menu.Item key="1">
                <Link to="/validate">
                  <div>
                    <Icon type="dashboard" />
                    <span>Add Claim </span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            <Menu.Item key="2">
              <Link to="/claims">
                <div>
                  <Icon type="file-protect" />
                  <span>Claims </span>
                </div>
              </Link>
            </Menu.Item>
            {this.state.loginUserRole == RoleIDMapping('Broker') && (
              <Menu.Item key="3">
                <Link to="/initiate-claim">
                  <div>
                    <ContainerOutlined />
                    <span>Initiate Claim </span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            <Menu.Item key="4">
              <Link to="/audit-trial">
                <div>
                  <ShrinkOutlined />
                  <span>Audit Trial</span>
                </div>
              </Link>
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout>
          <Header className="headerTop">
            <HeaderDiv toggleSidebar={this.toggleSidebar} />
            {/* <Icon
                className="trigger layout-trigger header-toggle"
                type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                onClick={this.toggle}
                />  */}
          </Header>
          <Content
            style={{
              padding: '65px , 35px',
              minHeight: '100vh',
            }}
            className={
              this.state.collapsed ? 'collapsed mainContnet ' : 'mainContnet'
            }>
            {this.props.children}
          </Content>
        </Layout>
      </Layout>
    )
  }
}
export default Layouts
